import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { IAdvancedRichText } from '../../../../../../../inputs/rich-text-advanced/IAdvancedRichText';
import { hasRichTextAdvanced } from '../../../../../../../inputs/rich-text-advanced/hasRichTextAdvanced';
import { OptionsGroupDivider } from './OptionsGroupDivider';
import { OptionsGroupRichTextAdvancedDividerLabelRender } from './OptionsGroupRichTextAdvancedDividerLabelRender';
import { OptionsGroupRichTextAdvancedDividerTextRender } from './OptionsGroupRichTextAdvancedDividerTextRender';
import { OptionsWrapper } from './OptionsWrapper';

export const OptionsGroupWrapper = styled.div`
  width: 100%;
  min-height: 40px;
  padding-bottom: 8px;
  .ant-checkbox-group,
  .ant-radio-group {
    min-height: 40px;
  }
  &.put-top-space {
    /* padding-top: 12px; */
  }
`;

function putTopSpace(props: OptionsGroupProps) {
  if (props.widgetHideLabel || !props.label) return false;
  return true;
}

export interface OptionsGroupProps {
  children?: React.ReactNode;
  label?: IAdvancedRichText;
  vertical?: boolean;

  labelLikeText?: boolean;
  widgetHideLabel?: boolean;
}

/**
 * Wrapper per gli stili grafici di configurazione delle opzioni.
 */
export function OptionsGroup(props: OptionsGroupProps) {
  const { label, children, vertical, labelLikeText } = props;

  return (
    <OptionsGroupWrapper
      className={clx({ 'put-top-space': putTopSpace(props) })}
    >
      {hasRichTextAdvanced(label) && (
        <OptionsGroupDivider>
          {labelLikeText ? (
            <OptionsGroupRichTextAdvancedDividerTextRender text={label} />
          ) : (
            <OptionsGroupRichTextAdvancedDividerLabelRender text={label} />
          )}
        </OptionsGroupDivider>
      )}
      <OptionsWrapper
        className={clx({
          vertical: vertical,
        })}
      >
        {children}
      </OptionsWrapper>
    </OptionsGroupWrapper>
  );
}
